'use strict';
var $ = require('jquery'),
    foreach = require('./utils/foreach'),
    Dispatcher;

Dispatcher = {
    _callbacks: [],
    /**
     * Register the callback
     *
     * @param {string} name - The key name of the callback (Used for waiting)
     * @param {function} callback - The callback to register
     */
    register: function (name, callback) {
        Dispatcher._callbacks.push({key: name, cb: callback});
    },
    /**
     * Dispatch the action over all the registered callbacks
     *
     * @param {object} action
     */
    dispatch: function (action) {
        var dfds = {};

        //I'm preparing all the deferred for the wait system
        foreach(Dispatcher._callbacks, function (registration) {
            dfds[registration.key] = new $.Deferred();
        });

        foreach(Dispatcher._callbacks, function (registration) {
            var cbDfd = registration.cb(action, dfds),
                name = registration.key;

            if (cbDfd && cbDfd.then) {
                cbDfd.then(
                    function () {
                        dfds[name].resolve.apply(dfds, arguments);
                    },

                    function () {
                        dfds[name].reject.apply(dfds, arguments);
                    }
                );
            } else {
                dfds[name].resolve();
            }
        });
    },
    applyMiddleware: function applyMiddleware(middleware) {
        var originalDispatch = Dispatcher.dispatch;

        Dispatcher.dispatch = function (action) {
            middleware(originalDispatch, action);
        };
    }
};

module.exports = Dispatcher;
